import { configureStore } from '@reduxjs/toolkit';
import { type TCreateStoreFunctionSignature } from '../../common/redux';
import { createMortgageMiniCalculatorApi } from '../api';
import { calculatorSlice } from './slices/calculatorSlice';
import { modalSlice } from './slices/modalSlice';
import { analyticSlice } from './slices/analyticSlice';

export const createMortgageMiniCalculatorStore = ((context, preloadedState, devTools) => {
  const mortgageMiniCalculatorApi = createMortgageMiniCalculatorApi(context);

  return configureStore({
    reducer: {
      [mortgageMiniCalculatorApi.reducerPath]: mortgageMiniCalculatorApi.reducer,
      [calculatorSlice.name]: calculatorSlice.reducer,
      [modalSlice.name]: modalSlice.reducer,
      [analyticSlice.name]: analyticSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ thunk: { extraArgument: context } }).concat(mortgageMiniCalculatorApi.middleware),
    preloadedState,
    devTools,
  });
}) satisfies TCreateStoreFunctionSignature;
